import { IoCaretForward, IoCaretBack } from 'react-icons/io5';
import { BsThreeDots } from 'react-icons/bs';
import styles from '../../assets/styles/Button.module.scss';
import { useMemo } from 'react';

export const Pagination = ({
	pageSize,
	limit,
	setPageSize,
	onLimitChange,
	totalItems,
	pageCount,
	currentPage,
	previousPage,
	setCurrentPage,
	pageOptions,
	gotoPage,
	nextPage,
}) => {
	const maxDisplayedPages = 3;
	const usedPageSize = Number(pageSize || limit || 50);
	const resolvedTotalPages =
		totalItems && usedPageSize
			? Math.ceil(totalItems / usedPageSize)
			: pageCount || pageOptions?.length || 0;
	const totalPages = Math.max(resolvedTotalPages, 1);
	const safeCurrentPage = Math.min(
		Math.max(currentPage || 0, 0),
		totalPages - 1
	);

	const goToPage = page => {
		const targetPage = Math.min(Math.max(page, 0), totalPages - 1);
		if (gotoPage) {
			gotoPage(targetPage);
		}
		if (setCurrentPage) {
			setCurrentPage(targetPage);
		}
	};

	const goToPrevious = () => {
		if (previousPage) {
			previousPage();
		}
		goToPage(safeCurrentPage - 1);
	};

	const goToNext = () => {
		if (nextPage) {
			nextPage();
		}
		goToPage(safeCurrentPage + 1);
	};

	const pageButtons = useMemo(() => {
		let pageButtons = [];
		if (totalPages <= maxDisplayedPages) {
			pageButtons = Array.from({ length: totalPages }, (_, index) => index);
			return pageButtons;
		} else {
			const startPage = Math.max(
				0,
				safeCurrentPage - Math.floor(maxDisplayedPages / 2)
			);
			const endPage = Math.min(
				totalPages - 1,
				startPage + maxDisplayedPages - 1
			);

			if (startPage > 0) {
				pageButtons.push('...');
			}

			pageButtons = pageButtons.concat(
				Array.from(
					{ length: endPage - startPage + 1 },
					(_, index) => startPage + index
				)
			);

			if (endPage < totalPages - 1) {
				pageButtons.push('...');
			}
			return pageButtons;
		}
	}, [totalPages, maxDisplayedPages, safeCurrentPage]);
	return (
		<div className={styles.pagination__group}>
			<div className={styles.pagination}>
				<select
					value={usedPageSize}
					onChange={e => {
						const newLimit = Number(e.target.value);
						if (setPageSize) {
							setPageSize(newLimit);
						}
						if (onLimitChange) {
							onLimitChange(newLimit);
						}
						goToPage(0);
					}}>
					{[50, 200, 300, 400, 500].map(pageSize => (
						<option key={pageSize} value={pageSize}>
							Show {pageSize}
						</option>
					))}
				</select>
				<strong>
					{safeCurrentPage + 1} of {totalPages}
				</strong>
			</div>
			<div className={styles.pagination}>
				<button
					onClick={goToPrevious}
					disabled={safeCurrentPage === 0}
					className={styles.numberedPage}>
					<IoCaretBack style={{ fontSize: '2rem' }} />
				</button>
				{pageButtons.map((page, index) =>
					page === '...' ? (
						<BsThreeDots key={index} style={{ fontSize: '2rem' }} />
					) : (
						<button
							key={index}
							onClick={() => goToPage(page)}
							className={`${styles.numberedPage} ${safeCurrentPage === page ? styles.numberPageActive : ''}`}>
							{page + 1}
						</button>
					)
				)}

				<button
					onClick={goToNext}
					disabled={safeCurrentPage >= totalPages - 1}
					className={styles.numberedPage}>
					<IoCaretForward style={{ fontSize: '2rem' }} />
				</button>
			</div>
		</div>
	);
};

export default Pagination;
